import { PageDataType } from '@common/paged-data/enums/page-data-type.enum';
import { AllFileFilter, ConditionalTagSetFileFilter, ProjectFileFilter, StylesheetsFileFilter, TargetFileFilter, TemplatePageFileFilter, TocFileFilter, VariableSetFileFilter } from '@portal-core/project-files/constants/file-filters.constants';
import { GridColumn } from '@portal-core/ui/grid/models/grid-column.model';
import { PageFilterConfigBase } from '@portal-core/ui/page-filters/util/page-filter-config-base';

export class WorkspaceFileTreeConfig extends PageFilterConfigBase {
  static readonly Columns: GridColumn[] = [
    {
      name: 'fileStatus',
      title: 'Status',
      type: PageDataType.Select,
      selectOptions: [{ id: 'false', text: 'Uncommitted Files', propertyType: PageDataType.Boolean }],
    },

    {
      name: 'fileType',
      title: 'Type',
      type: PageDataType.Select,
      selectOptions: [
        { id: AllFileFilter, text: 'Content Files', propertyType: PageDataType.Select },
        { id: ProjectFileFilter, text: 'Project Files', propertyType: PageDataType.Select },
        { id: TocFileFilter, text: 'TOCs', propertyType: PageDataType.Select },
        { id: TargetFileFilter, text: 'Target', propertyType: PageDataType.Select },
        { id: TemplatePageFileFilter, text: 'Template Page', propertyType: PageDataType.Select },
        { id: VariableSetFileFilter, text: 'Variable Sets', propertyType: PageDataType.Select },
        { id: ConditionalTagSetFileFilter, text: 'Condition Tag Sets', propertyType: PageDataType.Select },
        { id: StylesheetsFileFilter, text: 'Stylesheets', propertyType: PageDataType.Select }
      ],
      filterEnabled: true
    }
  ];

  constructor(enabledColumnNames?: string[]) {
    super(enabledColumnNames, WorkspaceFileTreeConfig.Columns);
  }
}



